exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._vue-flash-msg-body__text,._vue-flash-msg-body__title{margin:0!important}._vue-flash-msg-body__text{font-size:13px}._vue-flash-msg-body{width:25%;z-index:9999999}._vue-flash-msg-body__content h3{margin-top:.5rem;margin-bottom:.1rem;font-size:1.1rem}._vue-flash-msg-body ._vue-flash-msg-body__icon{background-color:hsla(0,0%,100%,0)!important}", ""]);

// exports
